'use client';
import { event_button_click } from '@/utils/gtm';

import RedirectToCheckout from '@/components/global/RedirectToCheckout';
import NextLink from '@/components/next-link';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import MiniCartItem from './mini-cart-item';

const MiniCart = ({ cartItems, total }) => {
  const t = useTranslations('common');

  return (
    <div className='blue-scroll border-border absolute end-0 top-full z-9999 hidden max-h-[450px] w-[350px] overflow-y-auto rounded-lg border bg-white py-3 pb-0 shadow group-hover:block'>
      <div className='border-b-border text-primary border-b bg-white px-3 py-1.5 pb-3 text-[15px]'>
        {t('Cart')}{' '}
        <span className='mx-1 font-medium text-black'>
          ({cartItems?.length} {t('items')})
        </span>
      </div>
      <ul className='blue-scroll max-h-[280px] overflow-y-auto'>
        {cartItems?.map((product) => (
          <MiniCartItem product={product} key={product?.item_id} />
        ))}
      </ul>
      {!cartItems?.length && (
        <div className='flex h-48 flex-col items-center justify-center'>
          <Image
            src='/imgs/empty-cart.png'
            alt='empty-cart'
            width={100}
            height={150}
            objectFit='cover'
            className='-mt-7 -mb-7 size-40 rounded-md'
          />
          <span className='max-w-2/3 text-center font-bold text-gray-400'>
            {t('No Items')}
          </span>
        </div>
      )}

      {!!cartItems?.length && (
        <div className='flex items-center justify-between gap-2 p-3'>
          <span className='font-bold text-zinc-700'>{t('total')} :</span>
          <span
            className={`flex items-center gap-1 font-bold text-black ${total <= 0 && 'text-green-500'}`}
          >
            {handlePriceByComma(total || 0)}{' '}
            <CurrencyIcon className='size-3.5' />
          </span>
        </div>
      )}

      {!!cartItems?.length && (
        <div className=''>
          <div className='flex items-center justify-center gap-2 px-3'>
            <NextLink
              href={'/cart'}
              onClick={() =>
                event_button_click({
                  button_name: 'View Cart',
                  button_destination: '/cart',
                  button_location: 'mini_cart',
                })
              }
              className='border-primary text-primary hover:bg-primary mb-3 flex w-full cursor-pointer items-center justify-center rounded-md border p-1.5 font-semibold hover:text-white'
            >
              {t('View Cart')}
            </NextLink>

            <RedirectToCheckout type={'fromMiniCart'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MiniCart;
